import Model from "../Model";

class KpiclientrepresentantZone2 extends Model{

    buildUrl ({ param }) {
        return ['kpiemployeeclientview/infobyzone', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiclientrepresentantZone2;